import { BrowserRouter, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { Navbar } from './components';

import { useStateContext } from './contexts/ContextProvider';
import './App.css';

import SolutionsTable from './components/SolutionsTable';
import StartupTable from './components/StartupTable';
import AdminCareers from './components/AdminCarrers';
import EventDashboard from './components/AdminEventDashboard';
import CofounderTable from './components/CoFounderTable';
import BusinessesTable from './components/BusinessesTable';
import BusinessTableConsultation from './components/BusinessConsultationTable';
import Ecommerce from './pages/Ecommerce';
import RecruitmentsTable from './components/RecruitmentsTable';
import AdminTestimonials from './components/AdminTestimonials';
import AdminInvestors from './components/AdminInvestors';
import FundingDashboard from './components/FundingDashboard';
import JobsDashboard from './components/JobsDashboard';
import JobsByUser from './components/JobsByUser';
import ApplicationDetail from './components/ApplicationDetail';
import EarningDashboard from './components/EarningDashboard';
import PaymentGateway from './components/PaymentGateway';
import CouponManagement from './components/Coupon';

import Login from './components/Login';
import AdminManager from './components/AdminManager';
import Subscription from './components/Subscription';
import RegistrationTable from './components/EventRegistrationTable';
import StageSectorIndustryUI from './components/StageSectorIndustryUI';
import Country from './partials/country';
import State from './partials/state';
import City from './partials/city';
import Religion from './partials/Religion';
import Caste from './partials/Caste';
import Dhosam from './partials/Dhosam';
import Gothram from './partials/Gothram';
import Occupation from './partials/Occupation';
import Zodiac from './partials/Zodiac';
import Header from './components/Header';
import Star from './partials/Star';
import MatrimonyProfiles from './partials/MatrimonyProfiles';
import FormBuilder from './components/FormBuilder';
import FormList from './components/FormList';
import FormView from './components/FormView';
import FormEdit from './components/FormEdit';
import Reports from './components/Reports';
import CloudCreditsTable from './components/CloudCredits';
import MotherTongue from './partials/MotherTongue';
import Education from './partials/Education';
import DocumentationTable from './components/Documentation';
import Mentors from './components/Mentors';
import CallToAction from './components/CallToAction';
import SectorContactList from './components/SectorContactlist';
import TactosCouponManagement from './components/TactosCoupon';
import HrApplications from './components/HrApplications';
import StartupIdeas from './components/StartupIdeas';
import Programs from './components/Programs';
import EventGallery from "./components/EventGallery";
{/* <Route path="/event-gallery" element={<EventGallery />} /> */}
import { ToastContainer } from 'react-toastify';
import AdminForum from './components/AdminForum';
import CommsionSetup from './components/CommsionSetup';
import InvestorsPitchDecks from './components/InvestorsPitchdecks';
import MeetingAppointmentTransactions from './components/MeetingAppointmentTransactions';
import MeetingBookings from './components/MeetingBookings';
import MentorsPayoutRequests from './components/MentorsPayoutRequests';

function ProtectedRoute({ isAuthenticated, children }) {
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

const OMIT_LAYOUT_PATHS = ['/login'];

function App() {
  const { currentMode } = useStateContext();

  return (
    <div className={currentMode === "Dark" ? "dark" : ''}>
      <BrowserRouter>
        <AppWrapper />
      </BrowserRouter>
    </div>
  );
}

function AppWrapper() {
  const { currentMode } = useStateContext();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return !!localStorage.getItem('admintoken');
  });

  const location = useLocation();
  const shouldOmitLayout = OMIT_LAYOUT_PATHS.includes(location.pathname);

  return (
    <div className="flex relative dark:bg-main-dark-bg">
      <ToastContainer />
      {isAuthenticated && (
        <div className={`fixed h-screen transition-all duration-300 bg-white dark:bg-secondary-dark-bg 
        ${isSidebarOpen ? 'w-20' : 'w-20'}`}>
          <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg w-full z-40 shadow-md">
            <Navbar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
          </div>
        </div>
      )}

      <div className={`min-h-screen transition-all duration-300 flex-1 
        ${isAuthenticated ? (isSidebarOpen ? 'ml-20' : 'ml-20') : 'ml-0'}`}>
        <div className="">
          {isAuthenticated && !shouldOmitLayout && (
            <Header
              category="Dashboard"
              title="Welcome Back"
              setIsAuthenticated={setIsAuthenticated}
            />
          )}
          <Routes>
            <Route path="/" element={
              isAuthenticated ? <Navigate to="/dashboard" /> : <Navigate to="/login" />
            } />
            <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} />} />

            <Route path="/dashboard" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Ecommerce />
              </ProtectedRoute>
            } />
            <Route path="/solutions" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <SolutionsTable />
              </ProtectedRoute>
            } />

            <Route
              path="/mentor"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <Mentors />
                </ProtectedRoute>
              }
            />
            <Route
              path="/appointments"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <MeetingBookings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/appointments/transaction"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <MeetingAppointmentTransactions />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mentorpayouts"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <MentorsPayoutRequests />
                </ProtectedRoute>
              }
            />
            <Route
              path="/forums"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <AdminForum />
                </ProtectedRoute>
              }
            />

            <Route
              path="/call-to-action"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <CallToAction />
                </ProtectedRoute>
              }
            />
            <Route
              path="/startupideas"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <StartupIdeas />
                </ProtectedRoute>
              }
            />

            <Route path="/startup-reg" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <StartupTable />
              </ProtectedRoute>
            } />
            <Route path="/career" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <JobsDashboard />
              </ProtectedRoute>
            } />
            <Route path="/events" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <EventDashboard />
              </ProtectedRoute>
            } />
            <Route path="/programs" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Programs />
              </ProtectedRoute>
            } />
            <Route path="/event-gallery" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <EventGallery />
              </ProtectedRoute>
            } />
            <Route path="/cofounder-reg" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <CofounderTable />
              </ProtectedRoute>
            } />
            <Route path="/business-idea-hub" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <BusinessesTable />
              </ProtectedRoute>
            } />
            <Route path="/business-consultation" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <BusinessTableConsultation />
              </ProtectedRoute>
            } />
            <Route path="/careers-apply" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <RecruitmentsTable />
              </ProtectedRoute>
            } />
            <Route path="/call-to-expert" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <SectorContactList />
              </ProtectedRoute>
            } />
            <Route path="/admin-testimonial" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <AdminTestimonials />
              </ProtectedRoute>
            } />
            <Route path="/admin-pitchdecks" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <InvestorsPitchDecks />
              </ProtectedRoute>
            } />
            <Route path="/admin-investors" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <AdminInvestors />
              </ProtectedRoute>
            } />
            <Route path="/fundings" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <FundingDashboard />
              </ProtectedRoute>
            } />
            <Route path="/earnings" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <EarningDashboard />
              </ProtectedRoute>
            } />
            <Route path="/coupons" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <CouponManagement />
              </ProtectedRoute>
            } />

            <Route path="/tactos-coupons" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <TactosCouponManagement />
              </ProtectedRoute>
            } />

            <Route path="/admin/jobs/:userId" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <JobsByUser />
              </ProtectedRoute>
            } />
            <Route path="/admin/application/:id" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <ApplicationDetail />
              </ProtectedRoute>
            } />
            <Route path="/addadmin" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <AdminManager />
              </ProtectedRoute>
            } />
            <Route path="/registrations/:eventId" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <RegistrationTable />
              </ProtectedRoute>
            } />
            <Route path="/datamanager" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <StageSectorIndustryUI />
              </ProtectedRoute>
            } />
            <Route path="/subscription" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Subscription />
              </ProtectedRoute>
            } />
            <Route path="/hr/applications" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <HrApplications />
              </ProtectedRoute>
            } />
            <Route path="/payment-gateway" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <PaymentGateway />
              </ProtectedRoute>
            } />
            <Route path="/reports" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Reports />
              </ProtectedRoute>
            } />
            <Route path="/documentation" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <DocumentationTable />
              </ProtectedRoute>
            } />
            <Route path="/cloud_credits" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <CloudCreditsTable />
              </ProtectedRoute>
            } />
            <Route path="/country" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Country />
              </ProtectedRoute>
            } />
            <Route path="/state" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <State />
              </ProtectedRoute>
            } />
            <Route path="/city" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <City />
              </ProtectedRoute>
            } />
            <Route path="/religion" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Religion />
              </ProtectedRoute>
            } />
            <Route path="/caste" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Caste />
              </ProtectedRoute>
            } />

            <Route path="/mother-tongue" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <MotherTongue />
              </ProtectedRoute>
            } />

            <Route path="/education" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Education />
              </ProtectedRoute>
            } />
            <Route path="/commission" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <CommsionSetup />
              </ProtectedRoute>
            } />

            <Route path="/dhosam" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Dhosam />
              </ProtectedRoute>
            } />
            <Route path="/gothram" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Gothram />
              </ProtectedRoute>
            } />
            <Route path="/occupation" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Occupation />
              </ProtectedRoute>
            } />
            <Route path="/zodiac" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Zodiac />
              </ProtectedRoute>
            } />
            <Route path="/star" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Star />
              </ProtectedRoute>
            } />
            <Route path="/profiles" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <MatrimonyProfiles />
              </ProtectedRoute>
            } />
            <Route path="/form-builder" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <FormBuilder />
              </ProtectedRoute>
            } />
            <Route path="/form-list" element={<FormList />} />
            <Route path="/form-view/:id" element={<FormView />} />
            <Route path="/form-edit/:id" element={<FormEdit />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default App;